<template>
  <div class="home">
    <fiexdHeader />
    <sideMenu />
    <mainContent>
      <router-view class="main" />
    </mainContent>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// @ is an alias to /src
import fiexdHeader from '@/components/header/header.vue';
import sideMenu from '@/components/menu.vue';
import mainContent from '@/components/mainContent.vue';

export default {
  name: 'Home',
  components: {
    fiexdHeader,
    sideMenu,
    mainContent,
  },
  data() {
    return {
    };
  },
  computed: mapGetters(['user']),
  mounted() {
    this.initApp();
    this.$store.dispatch('getProvince');
  },
  methods: {
    initApp() {
      // reload
      const { reload } = this.$route.query;
      if (reload) {
        this.$router.replace({ path: this.$route.path });
        window.location.reload();
      }
    },
  },
};
</script>